import { Component, OnInit } from '@angular/core';
import { ArticlePorteur } from "../../shared/articles/article";
import { ActivatedRoute, Router } from "@angular/router";
import { PorteurService } from "../../shared/porteur.service";
import { Porteur } from "../../shared/porteur";
import { SideBarService } from "../../../../shared/sidebar/side-bar.service";
import { SideBarComponent } from '../../../../shared/sidebar/side-bar-component';
import { ClientService } from "../../../../shared/client/client.service";

@Component({
  selector: 'app-dotation',
  templateUrl: './dotation.component.html',
  styleUrls: ['./dotation.component.scss']
})
export class DotationComponent extends SideBarComponent implements OnInit {

  articles: Array<ArticlePorteur> = new Array<ArticlePorteur>();
  porteur: Porteur;
  breakpoint;

  constructor(
    private porteurService: PorteurService,
    protected sideBar: SideBarService,
    protected router: Router,
    protected route: ActivatedRoute,
    private clientService: ClientService
  ) {
    super(sideBar, router, route);
  }

  ngOnInit() {
    super.ngOnInit();
    this.getPorteur();
    this.clientService.modifCodeService = this.porteur.codeService;
    this.onResize(window.innerWidth)
  }

  getPorteur() {
    this.route.parent.data.subscribe(data => {
      this.porteur = data.porteur;
      this.getArticles(data.porteur);
    })
  }

  getArticles(porteur: Porteur) {
    this.porteurService.getArticles(porteur).subscribe(data => {
      this.articles = data;
    })
  }

  editArticle(row: ArticlePorteur) {
    let outlets = {};
    outlets['sidebar'] = [row.code_article, row.taille, this.porteur.codeService, 'edit'];
    this.router.navigate([{ outlets }], {
      relativeTo: this.route,
      skipLocationChange: true
    }).then(() => this.sideBar.open())
  }

  addArticle() {
    this.router.navigate([{
      outlets: {
        sidebar: ['add-article']
      }
    }], {
      relativeTo: this.route,
      skipLocationChange: true
    }).then(() => this.sideBar.open())
  }

  onResize(event) {
    const x = event
    switch (true) {
      case (x <= 850):
        this.breakpoint = 1
        break
      case (x >= 850 && x <= 1300):
        this.breakpoint = 2
        break
      case (x >= 1300 && x <= 1700):
        this.breakpoint = 3
        break
      case (x > 1700):
        this.breakpoint = 4
        break
      default:
        this.breakpoint = 4
        break
    }
  }
}
